import { processTextResponse, type TextContentResult } from "./utils"
import { isAuthFailureResponse, withTokenRetry } from "./with-token-retry"

interface AuthedTextRequest {
  account: string
  userId: string
  getNeedSignTerms?: () => boolean
}

const TEXT_CONTENT_ACCEPT = "text/html, text/markdown, text/csv, text/plain, */*"

export async function getText(url: string, { account, userId, getNeedSignTerms }: AuthedTextRequest): Promise<TextContentResult> {
  try {
    const response = await withTokenRetry({
      account,
      userId,
      getNeedSignTerms,
      attempt: (token) => fetch(url, {
        credentials: "same-origin",
        headers: {
          Accept: TEXT_CONTENT_ACCEPT,
          "X-OmegaPoint-Code": token,
        },
      }),
      isAuthFailure: isAuthFailureResponse,
    })
    return await processTextResponse(response)
  } catch {
    return { kind: "error", status: 0 }
  }
}
